import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import { CONNECTION_OPTIONS } from './constants';
import FacebookLoginButton from './FacebookLoginButton';

const WizardButtons = ({
  step,
  setStep,
  connectionOption,
  eligibilityStep,
  existingStep,
  subStep,
  setEligibilityStep,
  handleGetStarted,
  handleEligibilityNext,
  handleExistingNext,
  handleBackStep,
  onLoginSuccess,
  onLoginFailed,
  accessToken,
  onComplete,
}) => {
  const renderNextButton = () => {
    switch (step) {
      case 1:
        return (
          <>
            <Button type="primary" className="get-started-button" onClick={handleGetStarted}>
              Get Started
            </Button>
            <Button type="link" variant="ghost" onClick={() => setStep(3)}>
              Skip and directly connect with Facebook
            </Button>
          </>
        );
      case 2:
        if (connectionOption === CONNECTION_OPTIONS.NEW) {
          if (eligibilityStep === 1) {
            switch (subStep) {
              case 'existing':
                return (
                  <>
                    <Button
                      type="primary"
                      className="get-started-button"
                      onClick={() => setEligibilityStep(2)}
                    >
                      I will migrate the number
                    </Button>
                    <Button type="link" variant="ghost" onClick={() => setEligibilityStep(2)}>
                      I will use a new number instead
                    </Button>
                  </>
                );
              case 'none':
                return (
                  <Button
                    type="primary"
                    className="get-started-button"
                    onClick={() => setEligibilityStep(2)}
                  >
                    I will get a new number
                  </Button>
                );
              default:
                return (
                  <>
                    <Button
                      type="primary"
                      className="get-started-button"
                      onClick={handleEligibilityNext}
                    >
                      Next
                    </Button>
                    <Button type="link" variant="ghost" onClick={() => setEligibilityStep(2)}>
                      Skip eligibility check
                    </Button>
                  </>
                );
            }
          } else {
            return (
              <>
                <Button type="primary" className="get-started-button" onClick={() => setStep(3)}>
                  Yes, I can access
                </Button>
                <Button type="link" variant="ghost" onClick={() => setStep(3)}>
                  I will create one later
                </Button>
              </>
            );
          }
        } else {
          if (existingStep === 1) {
            return (
              <>
                <Button type="primary" className="get-started-button" onClick={handleExistingNext}>
                  Next
                </Button>
                <Button type="link" variant="ghost" onClick={() => setStep(3)}>
                  Skip eligibility check
                </Button>
              </>
            );
          } else {
            return (
              <FacebookLoginButton
                onLoginSuccess={onLoginSuccess}
                onLoginFailed={onLoginFailed}
                accessToken={accessToken}
                isGettingStarted={false}
                buttonText="Migrate with Facebook"
              />
            );
          }
        }
      case 3:
        return (
          <FacebookLoginButton
            onLoginSuccess={onLoginSuccess}
            onLoginFailed={onLoginFailed}
            accessToken={accessToken}
            isGettingStarted={false}
            buttonText="Connect with Facebook"
          />
        );
      case 4:
        return (
          <Button type="primary" onClick={onComplete}>
            Complete
          </Button>
        );
      default:
        return null;
    }
  };

  return (
    <div className="button-group">
      <Button className="back-button" onClick={handleBackStep}>
        Back
      </Button>
      <div className="action-buttons">{renderNextButton()}</div>
    </div>
  );
};

WizardButtons.propTypes = {
  step: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
  connectionOption: PropTypes.string,
  eligibilityStep: PropTypes.number,
  existingStep: PropTypes.number,
  subStep: PropTypes.string,
  setEligibilityStep: PropTypes.func,
  handleGetStarted: PropTypes.func,
  handleEligibilityNext: PropTypes.func,
  handleExistingNext: PropTypes.func,
  handleBackStep: PropTypes.func,
  onLoginSuccess: PropTypes.func,
  onLoginFailed: PropTypes.func,
  accessToken: PropTypes.string,
  onComplete: PropTypes.func,
};

WizardButtons.defaultProps = {
  connectionOption: '',
  eligibilityStep: 1,
  existingStep: 1,
  subStep: '',
  handleGetStarted: () => {},
  handleEligibilityNext: () => {},
  handleExistingNext: () => {},
  handleBackStep: () => {},
  setEligibilityStep: () => {},
  onLoginSuccess: () => {},
  onLoginFailed: () => {},
  accessToken: '',
  onComplete: () => {},
};

export default WizardButtons;
